var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"accessory-list"},_vm._l((_vm.accessories),function(accessory){return _c('li',{key:accessory.id},[_c('router-link',{attrs:{"to":("/accessory/" + (accessory.id))}},[_vm._v(_vm._s(_vm.capitalize(accessory.name)))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }